/*
 * Copyright (c) 2022. Haodong JU
 */

import Category from '@/model/dish/Category'

export async function findABuffetPriceCategoryOrMakeOne () {
  const category = (await Category.getList(true)).find(it => it.dishesCategoryTypeId === 8)
  if (!category) {
    const res = (await Category.add({
      color: '#4caf50',
      langs: [{
        name: 'Buffet Preis',
        lang: 'DE',
      }, {
        name: 'Buffet Price',
        lang: 'EN',
      }, {
        name: '自助餐价格',
        lang: 'ZH',
      }],
      dishesCategoryTypeId: 8,
      printOrder: 10,
      categorySort: 888,
    })).content
    console.log(res)
    return res
  }
  return category
}

export async function findACouponCategoryOrMakeOne () {
  const category = (await Category.getList(true)).find(it => it.dishesCategoryTypeId === 13)
  if (!category) {
    const res = (await Category.add({
      color: '#4caf50',
      langs: [{
        name: 'Gutschein',
        lang: 'DE',
      }, {
        name: 'Coupon',
        lang: 'EN',
      }, {
        name: '代金券',
        lang: 'ZH',
      }],
      dishesCategoryTypeId: 13,
      printOrder: 10,
      categorySort: 888,
    })).content
    console.log(res)
    return res
  }
  return category
}

